//libs
import { useState } from "react";
import { DialogTitle } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";
import Message from "components/Message";

const plans = [
  {
    name: "Time Limitation",
    description:
      "We don't have enough time to fullfill the tender requirements",
  },
  {
    name: "Lacks to manpower",
    description:
      "We don't have enough manpower to fullfill the tender requirements",
  },
  {
    name: "Logistic Issues",
    description:
      "We don't have enough logistics to fullfill the tender requirements",
  },
  {
    name: "Others",
    description: "Please mention reasons below so that we can improve",
  },
];

const schema = yup.object({
  cancelReason: yup.string().required("Reason is required"),
  cancelComment: yup.string(),
});

export default function WithdrawTenderModal({ open, setOpen, onWithdraw }) {
  const [selected, setSelected] = useState(plans[0]);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ resolver: yupResolver(schema) , defaultValues: { cancelReason: plans[0].name } });

  const onSubmit = (values) => {
    onWithdraw({
      cancelReason: values.cancelReason,
      cancelComment: values.cancelComment,
    });
    setOpen(false);
  };

  return (
    <ModalDialog open={open} setOpen={setOpen}>
      <div className="space-y-6">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Cancel your tender
        </DialogTitle>
        <h4>Let us know the reason why you want to cancel your tender</h4>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset aria-label="Server size" className="space-y-2">
            {plans.map((plan) => (
              <label key={plan.name} className="block cursor-pointer">
                <div
                  className={`border ${
                    plan.name === selected.name
                      ? "border-teal-500 bg-teal-50"
                      : "border-gray-300"
                  } group relative flex items-start gap-x-4 rounded-lg px-6 py-4 shadow-sm focus:outline-none data-[focus]:border-teal-600 data-[focus]:ring-2 data-[focus]:ring-teal-600`}
                >
                  <input
                    type="radio"
                    value={plan.name}
                    {...register("cancelReason")}
                    className="mt-2 text-teal-500 focus:ring focus:ring-teal-500"
                    onChange={() => setSelected(plan)}
                  />
                  <div className="flex items-center">
                    <div className="text-sm/6">
                      <p className="font-semibold text-gray-900">{plan.name}</p>
                      <div className="flex gap-2 text-gray-500">
                        <div>{plan.description}</div>
                      </div>
                    </div>
                    <CheckCircleIcon className="ml-2 size-6 fill-teal-600 opacity-0 transition group-data-[checked]:opacity-100" />
                  </div>
                </div>
              </label>
            ))}
          </fieldset>
          <Message message={errors.cancelReason?.message} />
          <div className="mt-4">
            <label
              htmlFor="cancelComment"
              className="block text-sm font-medium text-gray-700"
            >
              Additional Comments
            </label>
            <textarea
              id="cancelComment"
              {...register("cancelComment")}
              rows="3"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500 sm:text-sm"
            />
          </div>
          <div className="sm:flex gap-2 mt-4">
            <Button type="submit">Cancel Tender</Button>
            <button
              type="button"
              data-autofocus
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </ModalDialog>
  );
}
